"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fileUrl = void 0;
exports.fileUrl = function (filename, props) {
    return "" + props.data.filters.file_url + filename;
};
//# sourceMappingURL=file-url.js.map